module.exports = __webpack_public_path__ + "img/glogo40.34b79bec.png";